import { createAsyncThunk } from "@reduxjs/toolkit";
import { dataServer } from "~/constants";

export interface SecureBulkDeleteConfig {
  table: string;
  ids: number[];
  idField?: string;
}

export interface DeleteThunkPayload {
  operations: SecureBulkDeleteConfig[];
}

export const genericDeleteThunk = createAsyncThunk(
  "data/genericDelete",
  async (payload: DeleteThunkPayload, { rejectWithValue }) => {
    console.log("genericDeleteThunk params", payload);

    if (!payload.operations || payload.operations.length === 0) {
      return rejectWithValue("No delete operations provided");
    }

    try {
      const url = `${dataServer}delete`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log("Generic delete response:", data);

      if (!response.ok) {
        throw new Error(data.error || "Delete operation failed");
      }

      return payload.operations;
    } catch (error: any) {
      console.error("genericDeleteThunk error:", error);
      return rejectWithValue(error.message || "Delete operation failed");
    }
  }
);